import { http } from "../api/http";

/**
 * Faz upload de mídia da propriedade
 */
export async function uploadPropertyMedia({
  file,
  auction_property_id,
  label,
  media_type,
  uploaded_by_user_id,
}) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("auction_property_id", auction_property_id);
  fd.append("media_type", media_type);

  if (label) fd.append("label", label);
  if (uploaded_by_user_id) {
    fd.append("uploaded_by_user_id", uploaded_by_user_id);
  }

  const res = await http.post("/property-media/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
}

/**
 * Cria nome padronizado para arquivos vindos do clipboard
 */
export function buildFileFromClipboard(file, labelBase, idx, defaultBase = "image") {
  const ext = file.type === "image/png" ? "png" : "jpg";
  const ts = new Date().toISOString().replace(/[:.]/g, "-");

  const base = (labelBase || defaultBase)
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-_]/g, "");

  const name = `${base}-${ts}-${idx + 1}.${ext}`;

  return new File([file], name, { type: file.type });
}
